import { render, staticRenderFns } from "./classQuiz_report.vue?vue&type=template&id=ddb73cf4&scoped=true&"
import script from "./classQuiz_report.vue?vue&type=script&lang=js&"
export * from "./classQuiz_report.vue?vue&type=script&lang=js&"
import style0 from "./classQuiz_report.vue?vue&type=style&index=0&id=ddb73cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb73cf4",
  null
  
)

export default component.exports